import { ChangeDate } from './ChangeDate';

const initChangeDate = () => {
  new ChangeDate({
    timer: true,
    start: "2024-01-26",
    end: '',
    period: 14,
    selectorCounter: "[data-counter]",
    data: {
      main: {
        total: 945,
        final: 45,
        rate: 27,
      },
      program: {
        total: 94,
        final: 12,
        rate: 6,
      },
    },
  });
};

export default initChangeDate;
